import React, { type JSX } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Checkbox,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Divider,
    Stack,
    Paper,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CancelOutlined, DragHandle, Search } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { InfoListItem } from '@brightlayer-ui/react-components';
import { Ups } from '@brightlayer-ui/icons-mui';
export const AddLoadGroups = (): JSX.Element => {
    const [selected, setSelected] = React.useState<any[]>([]);

    const loads = [
        {
            id: 1,
            title: 'Load Group 2',
            subtitle: 'UPS93PM-003 < Seattle < Northwest < Acme Energy',
            icon: <Ups sx={{ fontSize: 16, color: '#727e84' }} />,
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.',
        },
        {
            id: 2,
            title: 'Load Group 3',
            subtitle: 'UPS93PM-001 < Seattle < Northwest < Acme Energy',
            icon: <Ups sx={{ fontSize: 16, color: '#727e84' }} />,
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.',
        },
        {
            id: 3,
            title: 'Load Group 3',
            subtitle: 'UPS93PM-002 < Seattle < Northwest < Acme Energy',
            icon: <Ups sx={{ fontSize: 16, color: '#727e84' }} />,
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.',
        },
        {
            id: 4,
            title: 'Load Group 3',
            subtitle: 'UPS93PM-003 < Seattle < Northwest < Acme Energy',
            icon: <Ups sx={{ fontSize: 16, color: '#727e84' }} />,
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.',
        },
    ];

    const toggleSelect = (item: any): void => {
        setSelected((prev) => {
            const exists = prev.find((p) => p.id === item.id);
            if (exists) {
                return prev.filter((p) => p.id !== item.id);
            }
            return [...prev, item];
        });
    };

    const removeItem = (id: number): any => {
        setSelected((prev) => prev.filter((p) => p.id !== id));
    };

    const { t } = useTranslation();

    return (
        <Box p={3} display="flex" bgcolor="#F7F8F8" height="100vh">
            {/* Left Side */}
            <Card sx={{ width: '50%', overflow: 'hidden', backgroundColor: 'none' }}>
                <CardContent>
                    <Typography variant="h6" color="#727e54" mb={2} fontSize={16} fontWeight={600}>
                        Select Loads
                    </Typography>
                    <TextField
                        hiddenLabel
                        id="searchKey"
                        placeholder={t('COMMON:SEARCH_PLACEHOLDER')}
                        size="small"
                        InputProps={{
                            startAdornment: <Search id="search" sx={{ mr: '5px', color: '#727e84' }} />,
                            endAdornment: <CancelOutlined sx={{ color: '#727e84', cursor: 'pointer' }} />,
                        }}
                    />
                    <List>
                        {loads.map((item) => (
                            <InfoListItem
                                key={item.id}
                                title={item.title}
                                subtitle={[
                                    <>
                                        <Stack flexDirection={'row'} alignItems={'center'}>
                                            <Box pr={'8px'}>{item.icon}</Box>
                                            <Typography fontSize={12} fontWeight={400} color="#333D43">
                                                {item.subtitle}
                                            </Typography>
                                        </Stack>
                                    </>,
                                ]}
                                info={[
                                    <>
                                        <Typography fontSize={12} fontWeight={400} color="#333D43">
                                            {item.description}
                                        </Typography>
                                    </>,
                                ]}
                                onClick={() => toggleSelect(item)}
                                divider="full"
                                rightComponent={<Checkbox checked={!!selected.find((s) => s.id === item.id)} />}
                            />
                        ))}
                    </List>
                </CardContent>
            </Card>

            {/* Right Side */}
            <Card sx={{ width: '50%', overflowY: 'auto', backgroundColor: 'none' }}>
                <CardContent>
                    <Typography variant="body2" color="#424e54" mb={2} fontSize={16} fontWeight={600}>
                        Selected Load Groups
                    </Typography>
                    <Typography variant="body2" color="#424e54" mb={2} fontSize={16} fontWeight={400}>
                        Drag the Select Loads in the order you would like to view them. Total properties displayed (6)
                        in the widget can be modified in Display Preferences.
                    </Typography>
                    <Divider />
                    <Typography
                        variant="body2"
                        color="#424e54"
                        p={2}
                        fontSize={12}
                        fontWeight={600}
                        letterSpacing={'2px'}
                    >
                        Selected Load Groups
                    </Typography>
                    <Paper elevation={1} sx={{ borderRadius: 0 }}>
                        <List>
                            {selected.map((item) => (
                                <React.Fragment key={item.id}>
                                    <ListItem
                                        sx={{ display: 'flex', alignItems: 'center' }}
                                        secondaryAction={
                                            <IconButton onClick={() => removeItem(item.id)}>
                                                <CloseIcon />
                                            </IconButton>
                                        }
                                    >
                                        <ListItemIcon>
                                            <DragHandle />
                                        </ListItemIcon>
                                        <ListItemText primary={item.title} secondary={item.subtitle} />
                                    </ListItem>
                                    <Divider />
                                </React.Fragment>
                            ))}
                        </List>
                    </Paper>
                </CardContent>
            </Card>
        </Box>
    );
};
